<div class="item-tile" [style.width]="width">
  <div class="item-header" [style.backgroundImage]="image"></div>
  <div class="item-body">
    <div class="item-name">{{ item.name }}</div>
  </div>
</div>
